export default __webpack_public_path__ + "static/media/expand-more.453dd1ef.svg";